<main class="auth-shell min-h-screen px-4 py-10">
  <nz-alert
    class="responsibility-notice mx-auto w-full max-w-5xl"
    nzType="warning"
    [nzMessage]="'login.responsibilityTitle' | translate"
    [nzDescription]="responsibilityDescription"
    nzShowIcon
  ></nz-alert>

  <ng-template #responsibilityDescription>
    {{ 'login.responsibilityNoticeStart' | translate }}
    <a [href]="lawLinks.administrativeCode" target="_blank" rel="noopener noreferrer">{{ 'login.responsibilityLawAdministrative' | translate }}</a>,
    <a [href]="lawLinks.criminalCode" target="_blank" rel="noopener noreferrer">{{ 'login.responsibilityLawCriminal' | translate }}</a>
    {{ 'login.responsibilityNoticeAnd' | translate }}
    <a [href]="lawLinks.anticorruptionLaw" target="_blank" rel="noopener noreferrer">{{ 'login.responsibilityLawCorruption' | translate }}</a>{{ 'login.responsibilityNoticeEnd' | translate }}
  </ng-template>

  <section class="mx-auto grid w-full max-w-5xl items-center gap-8 pt-20 lg:grid-cols-[1fr_420px]">
    <div class="hidden lg:block">
      <div class="brand-mark mb-6">
        <span>{{ 'common.brand' | translate }}</span>
      </div>
      <p class="mb-3 text-sm font-semibold uppercase tracking-[0.22em] text-cyan-700">{{ 'login.ssoLabel' | translate }}</p>
      <h1 class="m-0 max-w-xl text-4xl font-semibold leading-tight text-slate-950">
        {{ 'login.heroTitle' | translate }}
      </h1>
      <p class="mt-5 max-w-lg text-base leading-7 text-slate-600">
        {{ 'login.heroSubtitle' | translate }}
      </p>
    </div>

    <div class="w-full">
      <nz-card class="auth-card w-full" [nzTitle]="'login.cardTitle' | translate">
      <nz-steps [nzCurrent]="currentStep" nzSize="small">
        <nz-step [nzTitle]="'login.stepSign' | translate"></nz-step>
        <nz-step [nzTitle]="'login.stepCredentials' | translate"></nz-step>
      </nz-steps>

      @if (currentStep === 0) {
        <div class="mt-6">
          <nz-alert
            nzType="info"
            [nzMessage]="'login.signRequiredTitle' | translate"
            [nzDescription]="'login.signRequiredDesc' | translate"
            nzShowIcon
          ></nz-alert>
        </div>

        <div class="mt-6">
          <button
            class="w-full"
            nz-button
            nzType="primary"
            type="button"
            [nzLoading]="isSigning"
            (click)="signWithCertificate()"
          >
            {{ 'login.signButton' | translate }}
          </button>
        </div>

        <div class="mt-3 flex justify-center">
          <button nz-button nzType="link" (click)="_router.navigate(['/register'])">
            {{ 'common.register' | translate }}
          </button>
        </div>
      }

      @if (currentStep === 1) {
        <form
          class="mt-6"
          [formGroup]="form"
          (ngSubmit)="tryAuthenticate()"
        >
          <nz-form-item>
            <nz-form-label>{{ 'common.iin' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="'login.iinError' | translate">
              <nz-input-wrapper>
                <nz-icon nzInputPrefix nzType="user"/>
                <input
                  nz-input
                  formControlName="login"
                  maxlength="12"
                  [placeholder]="'login.iinPlaceholder' | translate"
                >
              </nz-input-wrapper>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label>{{ 'common.psd' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="'login.psdRequired' | translate">
              <nz-input-password [(nzVisible)]="visible">
                <nz-icon nzInputPrefix nzType="lock"/>
                <input
                  nz-input
                  formControlName="password"
                  [placeholder]="'login.psdPlaceholder' | translate"
                >
              </nz-input-password>
            </nz-form-control>
          </nz-form-item>

          <div class="mt-6 flex flex-col gap-3">
            <button
              class="w-full"
              nz-button
              nzType="primary"
              type="submit"
              [nzLoading]="isAuthenticating"
              [disabled]="form.invalid"
            >
              {{ 'login.submit' | translate }}
            </button>

            <button
              class="w-full"
              nz-button
              nzType="link"
              type="button"
              (click)="openForgotPassword()"
            >
              {{ 'login.forgotPsd' | translate }}
            </button>

            <button
              class="w-full"
              nz-button
              nzType="default"
              type="button"
              (click)="backToSignStep()"
            >
              {{ 'common.back' | translate }}
            </button>
          </div>
        </form>
      }
      </nz-card>
    </div>
  </section>
</main>
